import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { validStockAgeingTypes } from "../../../Appconstants";
import { stockAgeing } from "../../../redux/actions/API/dashboardActions";
import InventoryExtra from "./InventoryExtra";
import { useEffect } from "react";

interface IStockAgeingItemsProps {
    stockAgeing: Function;
    stockAgeingState: any;
    stockAgeingLoading: boolean;
    companyId: any;
}

const StockAgeingItems: React.FC<IStockAgeingItemsProps> = ({
    companyId,
    stockAgeing,
    stockAgeingState,
    stockAgeingLoading,
}) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const typeIndexParam = Number(searchParams.get("typeIndex"));
    const hasValidTypeIndex = Number.isInteger(typeIndexParam) && typeIndexParam >= 0 && typeIndexParam < validStockAgeingTypes.length;
    const selectedTypeIndex = hasValidTypeIndex ? typeIndexParam : 0;

    const orderedTypeIndexes = hasValidTypeIndex
        ? [selectedTypeIndex, ...validStockAgeingTypes.map((_: string, index: number) => index).filter((index: number) => index !== selectedTypeIndex)]
        : validStockAgeingTypes.map((_: string, index: number) => index);

    const dropdownOptions = orderedTypeIndexes.map((index: number) => ({
        label: validStockAgeingTypes[index],
        value: index,
    }));

    useEffect(() => {
        const resolvedType = validStockAgeingTypes[selectedTypeIndex] || validStockAgeingTypes[0];

        stockAgeing({
            companyId: Number(companyId),
            type: resolvedType,
        });
    }, [companyId, selectedTypeIndex, stockAgeing]);

    const handleDropdownChange = (value: string | number) => {
        navigate(`/stockAgeingItems?typeIndex=${Number(value)}`);
    };

    return (
        <InventoryExtra
            breadcrumbTitle="Stock Ageing"
            dropdownOptions={dropdownOptions}
            loading={stockAgeingLoading}
            selectedValue={selectedTypeIndex}
            handleDropdownChange={handleDropdownChange}
            tableData={stockAgeingState}
        />
    );
};

const mapStateToProps = (state: any) => ({
    companyId: state.api.login?.data?.companyId,
    stockAgeingState: state.api.stockAgeing?.stockAgeing,
    stockAgeingLoading: state.api.stockAgeing?.loading,
});

const mapDispatchToProps = (dispatch: any) => ({
    stockAgeing: (payload: any) => dispatch(stockAgeing(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StockAgeingItems);
